import type { ApplicationDto, ExpenseExpectationDto, FundsExpenseDto } from '@/api/backend/users/applications';
import type { ApplicantExpense, PeriodicValue, PeriodKey } from '@/types';

const fromApiFrequency = (frequency: ExpenseExpectationDto['frequency']): PeriodKey => {
  const map: Record<string, PeriodKey> = {
    weekly: 'week',
    fortnightly: 'fortnight',
    monthly: 'month',
    quarterly: 'quarter',
    annually: 'year',
  };

  return map[frequency ?? 'monthly'] || 'month';
};

export const expenses = (applicantId: string, application: ApplicationDto): ApplicantExpense | null => {
  const applicant = (application.applicants ?? []).find((applicant) => applicant.id === applicantId);
  const expenseExpectation = (application.expenseExpectations ?? []).find((e) => e.applicantId === applicantId) || {};
  const predictedExpenseChange: PeriodicValue = {
    amount: expenseExpectation.expenseAmount ?? 0,
    frequency: fromApiFrequency(expenseExpectation.frequency),
  };

  const fundsExpenses =
    (application.fundsExpenses ?? []).filter((expense: FundsExpenseDto) => expense.applicantId === applicantId) || [];

  return fundsExpenses.length === 0
    ? null
    : Object.assign(
        {},
        {
          fundsExpenses,
          numberOfDependants: applicant?.numberOfDependants ?? 0,
          predictedExpenseChange,
          expenseChangeReason: expenseExpectation.expenseChangeReason,
          changesInLivingExpense: expenseExpectation.changesInLivingExpenses,
        },
      );
};
